export default "__VITE_ASSET__QZ4rvKbg__"